import {
  GenericAction,
  GenericActionKey,
  getPlatformConfig,
  PageActionKey,
  PageKey,
  PermissionConfig,
} from '@rendora/common/entities/app_cfg';
import { isServer } from '@rendora/design/utils/ssr';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { isCN, isPureHost } from '../utils/config';

// 私有化定制按钮权限
export const usePermissionStore = defineStore('permission', () => {
  const permissionConfig = ref<PermissionConfig>();
  const initialized = ref(false);

  const fetchPermissionConfig = async () => {
    const res = await getPlatformConfig();
    setPermissionConfig(res.data);
  };

  const setPermissionConfig = (res: PermissionConfig) => {
    permissionConfig.value = res;
    if (!isServer()) {
      // 判断是否存在 icon link
      let iconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
      if (!iconLink) {
        iconLink = document.createElement('link') as HTMLLinkElement;
        iconLink.rel = 'icon';
        document.head.appendChild(iconLink);
      }

      let IconUrl = res.config.head_icon_url || '';

      if (!isPureHost()) {
        IconUrl = isCN()
          ? 'https://www.youyan3d.com/favicon.ico'
          : 'https://www.rendora.ai/favicon-global.ico';
      }

      const typeIcon = !IconUrl.endsWith('.ico') ? 'image/png' : 'image/x-icon';
      iconLink.type = typeIcon;
      iconLink.href = IconUrl;
    }
    initialized.value = true;
  };

  const hasPagePermission = (pageName: PageKey) => {
    const pagePermission = permissionConfig.value?.pages?.find(page => page.key === pageName);

    if (!pagePermission) {
      return true;
    }

    return pagePermission.hasPermission;
  };

  const hasActionPermission = (actionName: GenericActionKey | PageActionKey) => {
    if (!permissionConfig.value || !initialized.value) {
      return true;
    }

    let pageActions: GenericAction | undefined;

    permissionConfig.value.pages?.find(page => {
      const action = page.actions?.find(action => action.key === actionName);
      if (action) {
        pageActions = action;
        return true;
      }
      return false;
    });

    pageActions =
      pageActions ||
      permissionConfig.value.genericActions?.find(action => action.key === actionName);

    if (pageActions) {
      return !!pageActions.hasPermission;
    }

    return false;
  };

  return {
    permissionConfig,
    initialized,
    fetchPermissionConfig,
    setPermissionConfig,
    hasPagePermission,
    hasActionPermission,
  };
});
